<template>
  <div>
    <el-row>
      <el-col>
        <el-form :inline="true" class="demo-form-inline" :model="searchForm" :ref="searchForm"
          style="margin: 0" size="medium">
          <el-form-item label="SKU名称：">
            <el-input minlength="2" v-model="searchForm.NAME" clearable @keyup.enter.native="filtrate()"></el-input>
          </el-form-item>
          <el-form-item label="SKU编码：">
            <el-input minlength="2" v-model="searchForm.CODE" clearable @keyup.enter.native="filtrate()"></el-input>
          </el-form-item>
          <el-form-item label="日期范围：">
            <el-date-picker v-model="searchForm.DAY_INTERVAL" type="daterange" align="right" unlink-panels
              range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions1"
              value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
          <el-button type="primary" @click="filtrate()">筛选</el-button>
          <el-button type="primary" plain @click="exportTable" v-if="fun_dic[101060001]">导出</el-button>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table :data="tableData" border stripe show-summary :summary-method="getSummaries">
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column prop="ORDER_ID" label="订单ID"></el-table-column>
          <el-table-column prop="SEND_DAY" label="送货日期"></el-table-column>
          <el-table-column prop="VENDOR_NAME" label="供应商"></el-table-column>
          <el-table-column prop="PRODUCT_CODE" label="产品编码"></el-table-column>
          <el-table-column prop="PRODUCT_NAME" label="产品名称"></el-table-column>
          <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
          <el-table-column prop="GYS_PRICE" label="价格"></el-table-column>
          <el-table-column prop="BEFORE_TAX_PRICE" label="不含税价格"></el-table-column>
          <el-table-column prop="TAX_RATE" label="税率"></el-table-column>
          <el-table-column prop="PRODUCT_COUNT" label="订购数量"></el-table-column>
          <el-table-column prop="REAL_COUNT" label="实收数量"></el-table-column>
          <el-table-column prop="PRODUCT_FEE" label="实收金额"></el-table-column>
          <el-table-column label="订单状态">
            <template slot-scope="scope">
              <span>{{ showStatus(scope.row.STATUS) }}</span>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { searchShopFun, exportShopFun } from '@/assets/api/shopOrderManage';
import { frontEndFun } from '@/assets/api/frontFun';

export default {
  data() {
    return {
      PAGE_ID: '1010600', // 页面ID 一旦规定不要轻易改动
      fun_dic: { 101060001: 0 }, // 功能ID 一旦规定不要轻易改动
      searchForm: {},
      customerLists: [],
      tableData: [],
      pickerOptions1: {},
    };
  },
  created() {
    this.queryBeforeFun();
  },
  methods: {
    // 控制功能按钮
    queryBeforeFun() {
      const params = {
        PAGE_ID: this.PAGE_ID,
      };
      frontEndFun(params).then((result) => {
        if (result.length !== 0) {
          this.forMenu(result, this.fun_dic);
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    forMenu(e) {
      const tmp_fun_list = e;
      for (let i = 0; i < tmp_fun_list.length; i++) {
        for (const key in this.fun_dic) {
          if (tmp_fun_list[i].FUNCTION_NUM == key) {
            this.fun_dic[key] = 1;
          }
        }
      }
    },
    filtrate() {
      this.currentPage = 0;
      this.queryData(this.currentPage);
    },
    queryData(e) {
      const params = {};
      if (this.searchForm.CODE) {
        if (/^\d*$/.test(String(this.searchForm.CODE))) {
          params.PRODUCT_CODE = this.searchForm.CODE;
        } else {
          this.$message.show({ text: '请输入正确的SKU编码', type: 'warning' });
          return false;
        }
      }
      if (this.searchForm.NAME) {
        params.PRODUCT_NAME = this.searchForm.NAME;
      }
      if (this.searchForm.DAY_INTERVAL) {
        params.START_DAY = this.searchForm.DAY_INTERVAL[0];
        params.END_DAY = this.searchForm.DAY_INTERVAL[1];
      }
      searchShopFun(params).then((result) => {
        if (result) {
          this.tableData = result.map((item) => Object.assign(item, { PRODUCT_CODE: item.PRODUCT_CODE.toString() }));
        } else {
          this.$message.show({ text: '暂无数据', type: 'success' });
          this.tableData = [];
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
        this.tableData = [];
      });
    },
    exportTable() {
      const params = {};
      if (this.searchForm.CODE) {
        params.PRODUCT_CODE = this.searchForm.CODE;
      }
      if (this.searchForm.NAME) {
        params.PRODUCT_NAME = this.searchForm.NAME;
      }
      if (this.searchForm.DAY_INTERVAL) {
        params.START_DAY = this.searchForm.DAY_INTERVAL[0];
        params.END_DAY = this.searchForm.DAY_INTERVAL[1];
      }
      exportShopFun(params).then((result) => {
        window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
        this.tableData = [];
      });
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if ([1, 2, 3, 4, 5, 6, 7, 8, 9, 13].includes(index)) {
          sums[index] = '';
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (!values.every((value) => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            }
            return prev;
          }, 0);
          sums[index] = Number(sums[index]).toFixed(2);
        } else {
          sums[index] = 'N/A';
        }
      });

      return sums;
    },
    showStatus(key) {
      switch (key) {
        case 1:
          return '待送订单';
        case 2:
          return '待验收订单';
        case 3:
          return '待确认订单';
        case 4:
          return '待确认订单';
        default:
          return '历史订单';
      }
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/shopOrderManage/searchShopOrder.vue